module.exports = __webpack_public_path__ + "img/wish_alter.7bc23099.png";